import styled from 'styled-components';
import { zIndex, spacing } from 'ui/theme';

const CONTAINER_WIDTH = '384px';

export const StyledToastContainer = styled.div`
  bottom: 16px;
  display: flex;
  flex-direction: column-reverse;
  gap: ${spacing.half};
  margin-left: 16px;
  overflow: visible;
  pointer-events: none;
  position: fixed;
  right: 16px;
  z-index: ${zIndex.toast};
  &[data-toasts-location='ToastsLocationStudio'] {
    bottom: 80px;
  }
  &[data-toasts-location='ToastsLocationCampaignEditorForTemplateEditor'] {
    bottom: 80px;
  }
  &[data-toasts-location='ToastsLocationStudioDrawer'] {
    right: 242px;
    bottom: 80px;
  }
  @media screen and (min-width: 400px) {
    width: ${CONTAINER_WIDTH};
  }
  @media screen and (max-width: 400px) {
    width: calc(100% - 32px);
    max-width: ${CONTAINER_WIDTH};
  }
`;
